<nb-card
  [accent]="
    student.finished
      ? 'success'
      : student.noLectureFinished
      ? 'warning'
      : 'info'
  "
>
  <nb-card-header>
    <div class="summary">
      <div class="item">
        <div class="avatar">
          <ngx-view-user-display
            [user]="student.author"
            [mode]="'avatar'"
          ></ngx-view-user-display>
        </div>

        <div class="content">
          <div class="content-header">
            <ngx-view-user-display
              [user]="student.author"
              [mode]="'name'"
            ></ngx-view-user-display>

            <ngx-view-time-ago
              [currentDate]="student.updatedOn"
            ></ngx-view-time-ago>
          </div>

          <div class="view-content">
            <button
              nbButton
              ghost
              size="small"
              [status]="
                student.finished
                  ? 'success'
                  : student.status === 0
                  ? 'warning'
                  : student.status === -1
                  ? 'danger'
                  : 'info'
              "
              (click)="overview(student)"
            >
              <nb-icon
                [icon]="
                  student.finished
                    ? 'award-outline'
                    : student.status === 0
                    ? 'email-outline'
                    : student.status === -1
                    ? 'activity-outline'
                    : 'trending-up-outline'
                "
              ></nb-icon>
              <span>{{
                student.finished
                  ? "Đã hoàn thành"
                  : student.status === 0
                  ? "Đã gửi lời mời"
                  : student.status === -1
                  ? "Đã từ chối"
                  : "Đang học"
              }}</span>
            </button>

            <nb-actions size="none">
              <nb-action>
                <nb-icon
                  status="success"
                  class="action-icon"
                  icon="menu-2-outline"
                ></nb-icon>
                <span>{{
                  student.noSectionFinished ? student.noSectionFinished : "0"
                }}</span>
              </nb-action>

              <nb-action>
                <nb-icon
                  status="info"
                  class="action-icon"
                  icon="book-open-outline"
                ></nb-icon>
                <span>{{
                  student.noLectureFinished ? student.noLectureFinished : "0"
                }}</span>
              </nb-action>

              <nb-action>
                <nb-icon
                  status="warning"
                  class="action-icon"
                  icon="layers-outline"
                ></nb-icon>
                <span>{{
                  student.noExerciseFinished ? student.noExerciseFinished : "0"
                }}</span>
              </nb-action>
            </nb-actions>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="button-action">
      <button
        nbButton
        ghost
        shape="round"
        status="primary"
        size="small"
        class="action-button"
        [disabled]="loading"
        [class.btn-pulse]="loading"
        [nbContextMenu]="menuItems"
        [nbContextMenuTag]="'action-buttons-' + student.id"
        (click)="loadButtonAction(student)"
      >
        <nb-icon icon="more-horizontal-outline"></nb-icon>
      </button>
    </div> -->
  </nb-card-header>

  <nb-card-footer>
    <div class="button-actions">
      <button
        nbButton
        ghost
        [status]="student.newMessage ? 'danger' : 'info'"
        size="small"
        (click)="reply()"
      >
        <nb-icon icon="message-square-outline"></nb-icon>

        <span *ngIf="!student.newMessage">Nhắn tin</span>

        <span *ngIf="student.newMessage" style="text-transform: lowercase">
          Xem tin nhắn
        </span>
      </button>

      <ngx-button-report-spam
        [student]="student"
        (onReport)="report($event)"
      ></ngx-button-report-spam>
    </div>

    <nb-card *ngIf="view === 'replies'" class="replies">
      <nb-card-body>
        <ngx-view-comments
          [student]="student"
          [mode]="'student'"
          (onClose)="closeReply()"
        >
        </ngx-view-comments>
      </nb-card-body>
    </nb-card>
  </nb-card-footer>
</nb-card>
